import { Button, Modal } from "antd";
import './style.scss'

type ModalExitoProps = {
    openModal: boolean,
    setOpenModal : Function,
    nombreInvitacion: string,
}

export const ModalExito = ({ openModal, setOpenModal, nombreInvitacion } : ModalExitoProps) => {

    const onAccept = () => {
        setOpenModal(!openModal);
    }

    return (
        <Modal
            className="ant-modal-close-x2"
            visible={openModal}
            width={662}
            footer={
                <div className="d-flex justify-content-center">
<Button 
                    onClick={ onAccept }
                    className="button-azul-radius justify-center"
                >
                    Aceptar
                </Button>

                </div>
                
            }  
        >
            <div className="modal__container">
                <h2 className="title__modal font-size-18px">Correo enviado con éxito</h2>
                <p className="modal__parrafo font-size-14px">Se ha enviado la invitación a jurado extemporáneo exitosamente</p>
                <p className="modal__parrafo modal__parrafo__bold font-size-14px">Hemos enviado un mensaje con las instrucciones de inscripción al banco de jurados para <span className="font-color-ff8900">{nombreInvitacion}</span></p>
            </div>
        </Modal>
    )
}
